import {classNames, Fragment, observer, React, Suspense, useEffect} from '@api'
import {AggregateDetailsStore, AggregateDetailsStoreContext, GroupAggregationFieldRenderer, ToggleAggregationLocationButton, useGroupByGroupStore, useVipLocalStore} from '@modules'
import * as css from './InlineAggregateDetails.css'
import {GroupDetailAggregationSectionConfig} from '@stores'

export const InlineAggregateDetails = observer<{ className?: string, style?: React.CSSProperties }, HTMLDivElement>(function InlineAggregateDetails({className, style}, ref) {
  const groupByStore = useGroupByGroupStore(),
    store = useVipLocalStore((ws) => new AggregateDetailsStore(ws, groupByStore?.pathIncludingSelfKeys)),
    {groupNode, config, data, loading, formatNumberValue, catalog} = store,
    {settings, aggregation: {aggregateDetailsGroup}} = catalog,
    sectionsToRender = (config?.sections ?? []).filter((s: GroupDetailAggregationSectionConfig) => s.inline !== false)

  useEffect(() => {
    (catalog.isProductView || groupNode?.store) && store.runQuery()
  }, [catalog.loadingCounts, catalog.isProductView, groupNode?.store, aggregateDetailsGroup, catalog.es.refetchId, catalog.es.aggregateDetailsRefetchId])

  // useEffect(() => {
  //   console.log(`Mount InlineAggregateDetails`)
  //   return () => console.log(`Unmount InlineAggregateDetails`)
  // }, [])

  if (catalog.settings.viewMode === 'pdf' || _.isEmpty(sectionsToRender)) return null

  return (
    <AggregateDetailsStoreContext.Provider value={store}>
      <Suspense fallback={null}>
        <div ref={ref}
             onDoubleClick={groupNode?.store?.onDoubleClick}
             className={classNames(css.root, className)}
             data-type='InlineAggregateDetails'
             data-group={groupNode?.store?.props?.info?.key}
             style={{...(style ?? {}), '--inline-columns': config?.inlineColumns ?? undefined} as any}>
          <div className={css.sections}>
            {sectionsToRender.map(({fields}, i) => (
              <Fragment key={i}>
                {fields.filter(f => !f.hidden && f.inline !== false).map((f, j) => {
                  if (settings.detailAggs[f.output ?? f.field] === false) return null

                  return <GroupAggregationFieldRenderer className={css.entry} key={j} f={f}/>
                })}
              </Fragment>))}
          </div>

          {!groupByStore && <ToggleAggregationLocationButton className={css.toggleAggregateLocationButton} />}
        </div>
      </Suspense>
    </AggregateDetailsStoreContext.Provider>
  )
}, {forwardRef: true})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/AggregateDetails/InlineAggregateDetails.tsx